// Shared by both checkout flows (single product and cart) so they cannot drift.
// Tabs need something to choose between, are meaningless for a pass (stripe
// only), and stay hidden while the shipping address is outstanding — a payment
// rail chooser above a shipping form reads as a rendering glitch. Once the
// address is submitted the tabs return, and switching provider keeps it.
const shouldShowProviderTabs = ({
  providers,
  isPass = false,
  awaitingShippingAddress = false,
}) => Boolean(
  providers?.length > 1 && !isPass && !awaitingShippingAddress
);

export default shouldShowProviderTabs;
